export const ASSIGN_TARGET_INDIVIDUAL = 1
export const ASSIGN_TARGET_MENTOR_GROUP = 2

export const ASSIGN_ICONS = {
  [ASSIGN_TARGET_INDIVIDUAL]: "avatar-plus",
  [ASSIGN_TARGET_MENTOR_GROUP]: "group-plus"
}
